/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseFinancialTermsResponse } from '../models/ApiResponseFinancialTermsResponse';
import type { ApiResponseGetFinancialAgreementResponse } from '../models/ApiResponseGetFinancialAgreementResponse';
import type { ApiResponseVoid } from '../models/ApiResponseVoid';
import type { CreateFinancialAgreementRequest } from '../models/CreateFinancialAgreementRequest';
import type { DeleteFinancialAgreementByHcsIdRequest } from '../models/DeleteFinancialAgreementByHcsIdRequest';
import type { DeleteFinancialAgreementByUserDeletionRequest } from '../models/DeleteFinancialAgreementByUserDeletionRequest';
import type { DeleteFinancialAgreementRequest } from '../models/DeleteFinancialAgreementRequest';
import type { SnakeStrategyApiResponseVoid } from '../models/SnakeStrategyApiResponseVoid';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class FinancialManagementControllerService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * 금융관리 약관 동의를 철회 합니다.
   * 금융관리 약관 동의를 철회 합니다. 동의모듈에서 user_id 로 철회하기 위해 호출.
   * @returns ApiResponseVoid OK
   * @throws ApiError
   */
  public deleteFinancialAgreementByUserDeletion({
    puid,
    requestBody,
  }: {
    puid: string,
    requestBody: DeleteFinancialAgreementByUserDeletionRequest,
  }): CancelablePromise<ApiResponseVoid> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/financial/v1/agreements/revoke/{puid}/user',
      path: {
        'puid': puid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 금융관리 약관 동의를 철회 합니다.
   * 금융관리 약관 동의를 철회 합니다. 동의모듈에서 user_id 로 철회하기 위해 호출.
   * @returns ApiResponseVoid OK
   * @throws ApiError
   */
  public deleteFinancialAgreementByUserDeletion1({
    puid,
    requestBody,
  }: {
    puid: string,
    requestBody: DeleteFinancialAgreementByUserDeletionRequest,
  }): CancelablePromise<ApiResponseVoid> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/financial/v1/agreements/revoke/{puid}/user/',
      path: {
        'puid': puid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 금융관리 약관 동의를 철회 합니다.
   * 금융관리 약관 동의를 철회 합니다.
   * @returns ApiResponseVoid OK
   * @throws ApiError
   */
  public deleteFinancialAgreement({
    requestBody,
  }: {
    requestBody: DeleteFinancialAgreementRequest,
  }): CancelablePromise<ApiResponseVoid> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/financial/v1/agreements/revoke/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 금융관리 약관 동의를 철회 합니다.
   * 금융관리 약관 동의를 철회 합니다.
   * @returns ApiResponseVoid OK
   * @throws ApiError
   */
  public deleteFinancialAgreement1({
    requestBody,
  }: {
    requestBody: DeleteFinancialAgreementRequest,
  }): CancelablePromise<ApiResponseVoid> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/financial/v1/agreements/revoke',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 금융관리 약관 동의를 철회 합니다. ( HCS 에서 호출하는 API )
   * 금융관리 약관 동의를 철회 합니다.
   * @returns SnakeStrategyApiResponseVoid OK
   * @throws ApiError
   */
  public deleteAgreementByHcs({
    requestBody,
  }: {
    requestBody: DeleteFinancialAgreementByHcsIdRequest,
  }): CancelablePromise<SnakeStrategyApiResponseVoid> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/financial/v1/agreements/hcs/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 금융관리 약관 동의를 철회 합니다. ( HCS 에서 호출하는 API )
   * 금융관리 약관 동의를 철회 합니다.
   * @returns SnakeStrategyApiResponseVoid OK
   * @throws ApiError
   */
  public deleteAgreementByHcs1({
    requestBody,
  }: {
    requestBody: DeleteFinancialAgreementByHcsIdRequest,
  }): CancelablePromise<SnakeStrategyApiResponseVoid> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/financial/v1/agreements/hcs',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 금융관리 약관 동의여부를 조회합니다.
   * 금융관리 약관 동의여부를 조회합니다.
   * @returns ApiResponseGetFinancialAgreementResponse OK
   * @throws ApiError
   */
  public getFinancialAgreements({
    puid,
  }: {
    puid: string,
  }): CancelablePromise<ApiResponseGetFinancialAgreementResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/financial/v1/agreements',
      query: {
        'puid': puid,
      },
    });
  }
  /**
   * 금융관리 약관에 동의 합니다.
   * 금융관리 약관에 동의 합니다.
   * @returns ApiResponseVoid OK
   * @throws ApiError
   */
  public createFinancialAgreement({
    authorization,
    requestBody,
  }: {
    authorization?: string,
    requestBody: CreateFinancialAgreementRequest,
  }): CancelablePromise<ApiResponseVoid> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/financial/v1/agreements',
      headers: {
        'Authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 금융관리 약관 동의여부를 조회합니다.
   * 금융관리 약관 동의여부를 조회합니다.
   * @returns ApiResponseGetFinancialAgreementResponse OK
   * @throws ApiError
   */
  public getFinancialAgreements1({
    puid,
  }: {
    puid: string,
  }): CancelablePromise<ApiResponseGetFinancialAgreementResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/financial/v1/agreements/',
      query: {
        'puid': puid,
      },
    });
  }
  /**
   * 금융관리 약관에 동의 합니다.
   * 금융관리 약관에 동의 합니다.
   * @returns ApiResponseVoid OK
   * @throws ApiError
   */
  public createFinancialAgreement1({
    authorization,
    requestBody,
  }: {
    authorization?: string,
    requestBody: CreateFinancialAgreementRequest,
  }): CancelablePromise<ApiResponseVoid> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/financial/v1/agreements/',
      headers: {
        'Authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 약관내용을 조회합니다.
   * 약관내용을 조회합니다.
   * @returns ApiResponseFinancialTermsResponse OK
   * @throws ApiError
   */
  public getFinancialTerms(): CancelablePromise<ApiResponseFinancialTermsResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/financial/v1/terms/',
    });
  }
  /**
   * 약관내용을 조회합니다.
   * 약관내용을 조회합니다.
   * @returns ApiResponseFinancialTermsResponse OK
   * @throws ApiError
   */
  public getFinancialTerms1(): CancelablePromise<ApiResponseFinancialTermsResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/financial/v1/terms',
    });
  }
}
